import { networkConfig } from "const";
import { ethers } from "ethers";

export async function getSigner(chainId) {
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  await provider.send("eth_requestAccounts", []);

  await provider.getNetwork();
  if (+provider.network.chainId !== +chainId) {
    alert("Please connect to the correct network");
    return;
  }
  return provider.getSigner();
}

export function getNetworkProvider(chainId) {
  const chainPrc = networkConfig[chainId].rpcUrls[0];
  return new ethers.providers.JsonRpcProvider(chainPrc);
}
